import { AfterViewInit, Component, inject, viewChild } from "@angular/core";
import { map } from "rxjs";
import { SearchType } from "../../shared/services/search-storage.service";
import { GenericSearchPageComponent } from "../generic-search-page/generic-search-page.component";
import { AgreementSearchService } from "./agreement-search.service";
import { AgreementSearchParameters } from "./types/AgreementSearchParameters";
import { AgreementSearchRow } from "./types/AgreementSearchRow";
import { filterDefinitions } from "./agreement-search-filters";
import { IFilterCategoryDef } from "../../shared/interfaces/IFilterDef";
import { LoadingService } from "../../shared/services/loading-overlay/loading-overlay.component";
import { VendorAgreementModal } from "../../modals/vendor-agreement-modal/vendor-agreement-modal.component";
import { AgreementSearchResultsGridComponent } from "./agreement-search-results-grid/agreement-search-results-grid.component";

@Component({
  selector: 'agreement-search',
  templateUrl: 'agreement-search.component.html',
  standalone: true,
  imports: [GenericSearchPageComponent, AgreementSearchResultsGridComponent],
  providers: [LoadingService, AgreementSearchService]
})
export class AgreementSearchComponent implements AfterViewInit {
  private searchService = inject(AgreementSearchService);
  private loadingService = inject(LoadingService);
  private agreementModal = inject(VendorAgreementModal);

  public SearchPageComponent = viewChild.required<GenericSearchPageComponent<AgreementSearchRow, AgreementSearchParameters>>(GenericSearchPageComponent);

  protected filterCategories: IFilterCategoryDef<AgreementSearchParameters>[] = filterDefinitions.filterCategories;
  protected searchHistoryType = SearchType.Agreements;
  protected searchFn = (params: AgreementSearchParameters) => this.searchService.SearchAgreements(params);
  protected editFn = (row: AgreementSearchRow) => this.agreementModal.ShowModal({
    Id: row.AgreementId,
    VendorId: row.VendorId,
    CanActivate: row.CanActivate
  }).pipe(map((a) => a !== undefined));

  ngAfterViewInit() {
    const loadRef = this.loadingService.StartWaiting("Loading Options...");
    this.searchService.GetDropdowns().subscribe((response) => {
      filterDefinitions.mapFiltersFromApi(response);
      this.SearchPageComponent().InitializeFilters();
      loadRef.Stop();
    });
  }
}
